import { RuntimeConfig } from '@/types/RuntimeConfig';

/**
 * Gets runtime configuration from Vite environment variables
 * This is the main function you should use to access config
 */
export function getConfig(): RuntimeConfig {
  const config: RuntimeConfig = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
    monoDomainUrl: import.meta.env.VITE_MONO_DOMAIN_URL || '',
  };

  // Validate that required fields are present
  if (!config.apiBaseUrl || !config.monoDomainUrl) {
    console.error('Missing required environment variables: VITE_API_BASE_URL or VITE_MONO_DOMAIN_URL');
  }

  return config;
}